import React, { useEffect, useState, Suspense, lazy } from "react";
import { Routes, Route, useLocation, useNavigate } from "react-router-dom";
import './App.css';

// Protected route handler
import Protected from './Protected';

// Page Components (keeping only non-lazy loaded components)
import UploadYourPrescription from './pages/UploadYourPrescription';
import UploadYourDociments from './pages/UploadYourDociments';
import ApprovalProcess from './pages/ApprovalProcess';
import AppointmentBooking from './pages/AppointmentBooking';
import ErrorDefaultScreen from "./pages/ErrorDefaultScreen";

// Authentication & Utility Components
import Guest from "./components/Auth/Guest";
import AccessManager from "./components/Layout/AccessManager";
import { saveUserData } from "./utils/Utils";
import LoadingProgressBar from "./pages/LoadingProgressBar";

// Lazy load all page components
const Register = lazy(() => import('./pages/Register/Register'));
const ApplicationForm = lazy(() => import('./pages/ApplicationForm/ApplicationForm'));
const Congratulations = lazy(() => import('./pages/Congratulations'));
const NoApproval = lazy(() => import('./pages/NoApproval'));
const PaymentSuccessful = lazy(() => import('./pages/PaymentSuccessful'));
const ErrorPayment = lazy(() => import('./pages/ErrorPayment'));
const Rejection = lazy(() => import('./pages/Rejection/Rejection'));
const TurnomeTestBooking = lazy(() => import('./pages/TurnomeTestBooking'));
const SlotBooking = lazy(() => import('./pages/SlotBooking'));
const OrderMyMedicine = lazy(() => import('./pages/OrderMyMedicine'));
const TreatmentPlan = lazy(() => import('./pages/TreatmentPlan'));
const TermsAndConditions = lazy(() => import('./pages/TermsAndConditions'));
const HomeCardEntryPoint = lazy(() => import('./pages/HomeCardEntryPoint'));

function App() {

  const location = useLocation();

  useEffect(() => {
      const queryParams = new URLSearchParams(location.search);
      const token = queryParams.get('token'); // Get the 'token' parameter from the URL
      if (token) {
          saveUserData(token)
      }
  }, [location]);
  return (
    <>
      <Suspense fallback={<LoadingProgressBar />}>
        <Routes>

           {/* Default route for guests (Registration Page) */}
           <Route path='/grafcare' element={<Guest Component={Register} />} />

          {/* Default route for guests (Registration Page) */}
          <Route path='/' element={<Guest Component={Register} />} />
          
          {/* Register route for guest users */}
          <Route path='register' element={<Guest Component={Register} />} />

          {/* Routes inside AccessManager (User must have access) */}
          <Route element={<AccessManager />}>
            {/* Application Form */}
            <Route path='application' element={<ApplicationForm />} />

            {/* Success page after approval */}
            <Route path='congratulations' element={<Protected Component={Congratulations} />} />

            {/* Page shown when approval is denied */}
            <Route path='no-approval' element={<Protected Component={NoApproval} />} />

            {/* Payment success page */}
            <Route path='payment-successful' element={<Protected Component={PaymentSuccessful} />} />

            {/* Payment failure or error screen */}
            <Route path='error-payment' element={<Protected Component={ErrorPayment} />} />
          </Route>
            <Route path='rejected' element={<Protected Component={Rejection} />} />

          {/* Mobile App Routes */}

          {/* Test Booking Page */}
          <Route path='turnome-test-booking' element={<TurnomeTestBooking />} />

          {/* Slot Booking Page */}
          <Route path='slot-booking' element={<SlotBooking />} />

          {/* Medicine Ordering Page */}
          <Route path='order-my-medicine' element={<OrderMyMedicine />} />

          {/* Treatment Plan Page (Medicine Adherence) */}
          <Route path='medicine-adherence' element={<TreatmentPlan />} />

          {/* Terms and Conditions Page (Currently Commented Out) */}
          <Route path='terms-conditions' element={<TermsAndConditions />} />

          {/* Home Entry Point (Dashboard) */}
          <Route path='home-entrypoint' element={<Protected Component={HomeCardEntryPoint} />} />
        </Routes>
      </Suspense>
    </>
  );
}

export default App;